module.exports = __webpack_public_path__ + "img/facebook.a494962e.svg";